export default __webpack_public_path__ + "static/unmuted-7aef9b6886b9a6695821aed9d2d1a3ac.png";